module.exports = __webpack_public_path__ + "static/media/nea-round.83b38055.png";